import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { etiquetaPrecio } from "../../data/precios";
import { desdeIvaIncluido, precioDesde } from "../../data/segmentos";
import WhatsAppCta from "./WhatsAppCta";

const FotoStickyCta = ({ segmento }) => {
  const [visible, setVisible] = useState(false);
  const desde = precioDesde(segmento);

  /*
    Sin requestAnimationFrame a propósito.
    
    El cálculo son dos lecturas de offset, así que no necesita coalescerse en
    un frame; y cuando el navegador estrangula rAF — pestaña en segundo plano,
    ahorro de energía, un panel de vista previa — el callback no llega nunca y
    la barra se queda escondida para siempre. En este proyecto ya pasó una vez
    con las animaciones de scroll: el CTA principal del móvil no puede depender
    de que el navegador conceda un frame.
  */
  useEffect(() => {
    const measure = () => {
      const hero = document.getElementById("inicio");
      const finalCta = document.getElementById("reservar");
      if (!hero || !finalCta) return;

      const scrolled = window.scrollY > hero.offsetTop + hero.offsetHeight * 0.65;
      const reachedFinal = finalCta.getBoundingClientRect().top < window.innerHeight * 0.85;
      setVisible(scrolled && !reachedFinal);
    };

    measure();
    window.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    return () => {
      window.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{ duration: 0.28, ease: "easeOut" }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-navy-800 bg-navy-900 px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] md:hidden"
        >
          <div className="flex items-center gap-3">
            <div className="min-w-0">
              <p className="text-xs text-sand-300">{segmento.packs.length > 1 ? "Desde" : `Por ${segmento.unidad}`}</p>
              <p className="truncate font-display text-lg font-extrabold tabular-nums text-white">
                {etiquetaPrecio(desde, { ivaIncluido: desdeIvaIncluido(segmento) })}
              </p>
            </div>
            <WhatsAppCta
              message={segmento.whatsapp}
              location="sticky_mobile"
              className="ml-auto shrink-0 !px-5 !py-3 !text-xs"
            >
              Pedir fecha
            </WhatsAppCta>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FotoStickyCta;
